import axios from "@/api/axiosInstance";
import { ArchiveCourseResponse } from "./types";

export const archiveCourse = async (
  uuid: string,
): Promise<ArchiveCourseResponse> => {
  const response = await axios.delete<ArchiveCourseResponse>(
    `/api/private/learning-center/courses/${uuid}`,
  );
  return response.data;
};
